export default{
  illus: {
    logo: require('../../assets/img/illustrationx.svg'),
    logorev: require('../../assets/img/illustrationx-white.svg'),
    alt: 'IllustrationX'
  },
  anim: {
    logo: require('../../assets/img/animationx.svg'),
    logorev: require('../../assets/img/animationx-white.svg'),
    alt: 'AnimationX'
  }
}